<template>
  <section class="register-container">
    <wechat-login
      v-if="showWechatLogin"
      :status="wechatStatus"
      :check-unread-info="checkUnreadInfo"
      :check-login-times="checkLoginTimes"
      :auto-to-tool="autoToTool"
      @backClick="backClick"
      @loginSucc="loginSuccHdl"
    >
    </wechat-login>
    <div
      v-else
      class="register-form"
      @click="validate.allMsg = ''"
    >
      <div>
        <div class="register-form-title">
          <p
            class="title-p"
            @click="goTo('login')"
          >
            登录
          </p>
          <p class="title-p-active">
            注册
          </p>
        </div>
        <div class="form">
          <input
            v-model="registerdata.phoneNum"
            placeholder="请输入手机号/邮箱"
            autocomplete="off"
            @focus="clearValidate('phone')"
            @blur="phoneORemail"
          >
          <div
            v-if="validate.phoneNum"
            class="check-right"
          ></div>
          <p class="error">
            {{ validate.phoneNumMsg }}
          </p>
        </div>
        <div class="form">
          <input
            v-model="registerdata.psw"
            :type="pwdType"
            autocomplete="off"
            placeholder="请输入密码(6-20位数字或英文)"
            @click="clearValidate('psw')"
            @blur="checkPsw"
          >
          <div
            v-if="registerdata.psw"
            class="pwd-clear"
            @click="registerdata.psw = ''"
          >
            <iconfont-hover
              width="10px"
              height="10px"
              initial-name="#icon-close"
              hover-name="#icon-close-hover"
              class="close-btn"
            >
            </iconfont-hover>
          </div>
          <!-- <div
                        class="pwd-show"
                        :class="{ active: idPwdShow }"
                        @click="changePwdType">
                    </div> -->
          <div @click="changePwdType">
            <iconfont-hover
              v-if="idPwdShow"
              class="pwd-show"
              width="16px"
              height="16px"
              initial-name="#icon-showpwd"
              hover-name="#icon-showpwd-hover"
            >
            </iconfont-hover>
            <iconfont-hover
              v-else
              class="pwd-show"
              width="16px"
              height="16px"
              initial-name="#icon-hidepwd"
              hover-name="#icon-hidepwd-hover"
            >
            </iconfont-hover>
          </div>
          <div
            v-if="validate.psw"
            class="check-right"
          ></div>
          <p class="error">
            {{ validate.pswMsg }}
          </p>
          <p class="error">
            {{ validate.allMsg }}
          </p>
        </div>
        <div class="form-box">
          <div
            class="form"
            style="width:188px;"
          >
            <input
              v-model="imgsrc.captcha"
              style="width:186px;"
              placeholder="图形验证码"
              @focus="clearValidate('img')"
              @change="changeCaptcha"
            >
            <p class="error imgerror">
              {{ validate.imgCaptchaMsg }}
            </p>
            <div
              v-if="validate.imgCaptcha"
              class="check-right code-right"
            ></div>
          </div>
          <span class="form-imgcaptcha">
            <img
              :src="'/webapi' + imgsrc.imgurl"
              @click="refreshCaptcha"
            >
          </span>
        </div>
        <div class="form-box">
          <div
            class="form"
            style="width:188px;"
          >
            <input
              v-model="registerdata.verifyCode"
              style="width:186px;"
              placeholder="请输入验证码"
              @focus="clearValidate('code')"
            >
            <p class="error varifyerror">
              {{ validate.verifyCodeMsg }}
            </p>
            <div
              v-if="validate.verifyCode"
              class="check-right code-right"
            ></div>
          </div>
          <button
            ref="regBtn"
            class="form-getcode"
            @click="reSendVerifyCode"
          >
            获取验证码
          </button>
        </div>
      </div>
      <button
        :disabled="btnDisabled"
        :class="{ 'sbtn-disabled': btnDisabled }"
        @click="submit('register')"
      >
        注&nbsp;&nbsp;册
      </button>
      <div class="a-desc">
        注册即视为同意<a
          href="/about?id=9"
          target="_blank"
        >
          《用户服务协议》
        </a>
      </div>
      <div class="a-desc">
        已是来画用户？去<a
          style="text-decoration: underline;"
          @click="goTo('login')"
        >
          登录
        </a>
      </div>
    </div>
    <div class="login-line">
      换个姿势登录
    </div>
    <div class="other-login">
      <div
        v-if="!showWechatLogin"
        class="option"
        style="margin-right: 62px;"
        @click="oauthlogin(3)"
      >
        <svg
          class="iconfont signinicon1"
          aria-hidden="true"
        >
          <use xlink:href="#icon-sign-wechat"></use>
        </svg>
      </div>
      <div
        class="option"
        style="margin-right: 62px;"
        @click="oauthlogin(1)"
      >
        <svg
          class="iconfont signinicon2"
          aria-hidden="true"
        >
          <use xlink:href="#icon-signin-weibo"></use>
        </svg>
      </div>
      <div
        class="option"
        @click="oauthlogin(2)"
      >
        <svg
          class="iconfont signinicon3"
          aria-hidden="true"
        >
          <use xlink:href="#icon-signin-qq"></use>
        </svg>
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'RegisterDialog',
  components: {
    wechatLogin: () => import('@/components/user/wechatLogin')
  },
  props: {
    wechatStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      idPwdShow: false,
      registerPwd: '',
      pwdType: 'password',
      countdown: 60,
      registerdata: {
        phoneNum: '', // 手机号
        verifyCode: '', // 验证码
        psw: '', // 密码
        captcha: ''
      },
      imgsrc: {
        // 图形验证码
        captcha: '',
        imgurl: ''
      },
      validate: {
        //校验
        phoneNum: false,
        phoneNumMsg: '',
        imgCaptcha: false,
        imgCaptchaMsg: '',
        verifyCode: false,
        verifyCodeMsg: '',
        psw: false,
        pswMsg: '',
        allMsg: ''
      },
      userId: false, // 用户id
      stop_msg: false, // 控制修改phone，图形验证码的修改
      jphoneORemail: 0, // 手机0 邮箱1
      postFlag: false, //请求防重
      weChatImgUrl: '',
      otherFlag: false, //其他输入框需校验正确
      isSendCode: false,
      nextDisalbed: true,
      btnDisabled: true,
      isAc: 0, //是否在pc端大赛页面发起登录,0普通，1pc大赛，2app大赛
      showWechatLogin: false, // 微信登录
      timer: null // 计时器
    }
  },
  computed: {
    ...mapGetters(['routeParam', 'countDownInfo'])
  },
  watch: {
    imgsrc: {
      handler: function(val) {
        this.registerdata.captcha = val.captcha
      },
      deep: true
    },
    registerdata: {
      handler: function(val) {
        //只要都不为空按钮可点击
        this.btnDisabled = val.phoneNum == '' || val.verifyCode == '' || val.captcha == '' || val.psw == '' ? true : false
      },
      deep: true
    },
    validate: {
      handler: function(val) {
        this.otherFlag = val.phoneNum && val.imgCaptcha && val.psw
      },
      deep: true
    },
    wechatStatus(val) {
      if (!val) {
        this.beforeClose()
      } else {
        this.refreshCaptcha()
      }
    }
  },
  mounted() {
    this.isAc = this.$route.path == '/contest' ? 1 : 0
    this.refreshCaptcha()
  },
  beforeDestroy() {
    this.beforeClose()
  },
  methods: {
    ...mapMutations(['changeLogin', 'changeRegisterVisible', 'changeUnreadMsgInfo']),
    beforeClose() {
      clearTimeout(this.timer)
      this.registerdata.phoneNum = ''
      this.registerdata.verifyCode = ''
      this.registerdata.psw = ''
      const validate = {
        phoneNum: false,
        phoneNumMsg: '',
        imgCaptcha: false,
        imgCaptchaMsg: '',
        verifyCode: false,
        verifyCodeMsg: '',
        psw: false,
        pswMsg: ''
      }
      this.imgsrc.captcha = ''
      this.validate = validate
      this.$refs.regBtn.removeAttribute('disabled')
      this.$refs.regBtn.innerText = '获取验证码'
      this.countdown = 60
      this.stop_msg = false
      this.isSendCode = false
      this.changeRegisterVisible(false)
    },
    loginSuccHdl() {
      // 这里需要把当前弹窗关闭
      this.$bus.emit('bus::wechatLogin')
    },
    changeCaptcha() {
      this.validate.imgCaptcha = false
      this.validate.imgCaptchaMsg = ''
    },
    //清除校验
    clearValidate(type) {
      switch (type) {
        case 'phone':
          this.validate.phoneNum = false
          this.validate.phoneNumMsg = ''
          break
        case 'img':
          if (!this.validate.verifyCode) {
            this.validate.imgCaptcha = false
          }
          this.validate.imgCaptchaMsg = ''
          break
        case 'code':
          this.validate.verifyCode = false
          this.validate.verifyCodeMsg = ''
          break
        case 'psw':
          this.validate.psw = false
          this.validate.pswMsg = ''
          break
      }
    },
    //显示隐藏密码
    changePwdType() {
      this.idPwdShow = !this.idPwdShow
      this.pwdType = this.pwdType === 'password' ? 'text' : 'password'
    },
    //请求校验账号是否被注册
    checkAcc() {
      return new Promise((resolve, reject) => {
        this.$http
          .get('/register/account', {
            params: { acc: this.registerdata.phoneNum }
          })
          .then((response) => {
            var _data = response.data
            if (_data.code == 200) {
              resolve(true)
            } else {
              this.validate.phoneNumMsg = _data.msg
            }
          })
      })
    },
    //手机号或邮箱注册
    async phoneORemail() {
      let email = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      let phone = /^(0|86|17951|12593)?((13[0-9])|(14[014]0[0-9])|(14[5-9])|(15([0-3]))|(15([5-9]))|(16[2567])|(170[0-9])|(174[0-5])|(17[1235678])|(18[0-9])|(19[012356789]))\d{8}$/
      if (this.registerdata.phoneNum == '') {
        this.validate.phoneNumMsg = '请输入手机号或邮箱'
        this.validate.phoneNum = false
        return false
      } else if (email.test(this.registerdata.phoneNum)) {
        let result = await this.checkAcc()
        if (result) {
          this.jphoneORemail = 1
          this.validate.phoneNum = true
          return true
        }
      } else if (phone.test(this.registerdata.phoneNum)) {
        let result = await this.checkAcc()
        if (result) {
          this.jphoneORemail = 0
          this.validate.phoneNum = true
          return true
        }
      } else {
        this.validate.phoneNumMsg = '请输入正确手机号码或邮箱'
        this.validate.phoneNum = false
        return false
      }
    },
    //更新图形验证码
    refreshCaptcha() {
      var times = Date.parse(new Date())
      this.imgsrc.imgurl = '/verify/imgCaptcha/new' + '?num=' + times
      this.validate.imgCaptcha = false
    },
    //校验图形验证码
    checkCaptchaImg() {
      if (this.imgsrc.captcha != '' && !this.validate.imgCaptcha) {
        return new Promise((resolve, reject) => {
          this.$http
            .put('/verify/imgCaptcha', {
              captcha: this.imgsrc.captcha
            })
            .then((response) => {
              var _data = response.data
              if (_data.code == 200) {
                this.validate.imgCaptcha = true
                resolve(true)
              } else {
                this.validate.imgCaptchaMsg = _data.msg //"图形验证码错误";
                resolve(false)
              }
            })
            .catch((response) => {
              //失败
              reject(false)
            })
        })
      } else if (this.imgsrc.captcha == '') {
        this.validate.imgCaptchaMsg = '请输入图形验证码'
        return false
      } else {
        return true
      }
    },
    //判断账号和图形验证码是否都校验通过
    checkAccAndImg() {
      if (this.validate.phoneNum && this.validate.imgCaptcha) {
        this.isSendCode = false
      }
    },
    //重新发送验证码
    async reSendVerifyCode() {
      // 神策埋点：点击获取短信验证码按钮
      this.$store.commit('sensors/getCode2Sensors', { serviceType: '注册' })

      // this.$refs.regBtn.setAttribute("disabled", true);
      const isAcc = await this.phoneORemail()
      // console.log("isAcc>>>>>>>>",isAcc,"---------")
      const isImgc = await this.checkCaptchaImg()
      if (!isImgc) {
        this.refreshCaptcha()
      }
      if (!(isAcc && isImgc)) {
        // console.log("111111111")
        return
      } else if (!this.isSendCode) {
        // console.log("222222222")
        this.sendVerifyCode()
      } else {
        // console.log("333333333")
        this.refreshCaptcha()
        this.imgsrc.captcha = ''
        this.validate.imgCaptchaMsg = '请输入图形验证码'
        this.validate.verifyCodeMsg = ''
        this.validate.verifyCode = false
        this.registerdata.verifyCode = ''
        this.isSendCode = false
      }
    },
    //发送验证码
    sendVerifyCode() {
      this.$http
        .get('/verify/new', {
          params: {
            phone: this.jphoneORemail == 0 ? this.registerdata.phoneNum : '',
            email: this.jphoneORemail == 1 ? this.registerdata.phoneNum : '',
            captcha: this.imgsrc.captcha,
            servide_type: '注册'
          }
        })
        .then((response) => {
          var _data = response.data
          // console.log("获取验证码后的操作",_data.code,"-------")
          switch (_data.code) {
            case 200:
              this.isSendCode = true
              this.setTime()
              break
            case 400:
              this.validate.verifyCodeMsg = _data.msg
              break
            case 412:
              this.validate.imgCaptchaMsg = _data.msg //"图形验证码错误";
              break
            case 416:
              this.validate.imgCaptchaMsg = '请输入图形验证码'
              break
          }
        })
        .catch((response) => {
          //失败
        })
    },
    //校验验证码
    checkVerifyCode() {
      return new Promise((resolve, reject) => {
        this.$http
          .put('/verify', {
            phone: this.jphoneORemail == 0 ? this.registerdata.phoneNum : '',
            email: this.jphoneORemail == 1 ? this.registerdata.phoneNum : '',
            code: this.registerdata.verifyCode
          })
          .then((response) => {
            var _data = response.data
            switch (_data.code) {
              case 200:
                this.validate.verifyCode = true
                resolve(true)
                break
              default:
                this.validate.verifyCodeMsg = '验证码错误'
                resolve(false)
            }
          })
          .catch((response) => {
            //失败
            reject()
          })
      })
    },
    //验证码计时
    setTime() {
      // console.log("this.wechatStatus",this.wechatStatus,"------------")
      // if (!this.wechatStatus) {
      //     return;
      // }
      var CT = () => {
        this.countdown--
        if (this.countdown == 0) {
          this.$refs.regBtn.removeAttribute('disabled')
          this.$refs.regBtn.innerText = '重新获取验证码'
          this.countdown = 60
          this.stop_msg = false
          return false
        } else {
          this.$refs.regBtn.setAttribute('disabled', true)
          this.$refs.regBtn.innerText = '重新发送(' + this.countdown + ')'
          this.stop_msg = true
        }
        if (parseInt(this.countdown) > 0) {
          this.timer = setTimeout(function() {
            CT()
          }, 1000)
        } else {
          this.countdownVisible = false
          clearTimeout(this.timer)
          //结束倒计时
        }
      }
      CT()
    },
    //下一步
    async nextStep() {
      //校验验证码
      const codeFlag = await this.checkVerifyCode()
      return codeFlag
    },
    //校验密码格式是否正确
    checkPsw() {
      let reg = /^[a-zA-Z0-9]{6,20}$/
      if (!reg.test(this.registerdata.psw)) {
        this.validate.pswMsg = '请输入6-20位数字或英文'
        this.validate.psw = false
        return false
      }
      this.validate.pswMsg = ''
      this.validate.psw = true
      return true
    },
    //非空校验
    isNull() {
      let flag = true
      const valid = [
        { name: 'phoneNum', text: '帐号' },
        { name: 'verifyCode', text: '验证码' },
        { name: 'psw', text: '密码' }
      ]
      for (const [key, val] of Object.entries(this.registerdata)) {
        valid.forEach((item) => {
          if (item.name == key && val == '') {
            this.validate[key] = false
            this.validate[key + 'Msg'] = '请输入' + item.text
            flag = false
          }
        })
      }
      if (this.imgsrc.captcha == '') {
        this.validate.imgCaptcha = false
        this.validate.imgCaptchaMsg = '请输入图形验证码'
        flag = false
      }
      return flag
    },
    getRegisterSource() {
      this.$route.path
    },
    //提交注册
    submit() {
      // 上一次提交注册请求未结束
      if (this.postFlag) return

      // 神策埋点：记录注册触发源
      if (this.$route.path === '/wbsignin') {
        this.$store.commit('sensors/setregisterSuccessSource', {
          route: this.$route,
          name: '发现页注册'
        })
      }
      let utmParam = this.$.storage.get('utmParam') || this.routeParam
      let param = {}
      if (utmParam) {
        let arr = utmParam.split('&')
        arr.forEach((i) => {
          param[i.split('=')[0]] = i.split('=')[1]
        })
      }
      this.postFlag = true
      const registerSuccessSource = this.$store.getters['sensors/registerSuccessSource']
      this.$http
        .post('/register', {
          phone: this.jphoneORemail == 0 ? this.registerdata.phoneNum : '',
          email: this.jphoneORemail == 1 ? this.registerdata.phoneNum : '',
          code: this.registerdata.verifyCode,
          psw: this.registerdata.psw,
          repsw: this.registerdata.psw,
          // 神策上报：注册来源
          register_source: registerSuccessSource ? registerSuccessSource.name : '非指定来源',
          ...param
        })
        .then((response) => {
          var _data = response.data
          if (_data.code == 200) {
            this.login(this.registerdata.phoneNum, this.registerdata.psw)
            this.changeRegisterVisible(false)
            if (this.$route.name === 'wbsignin') {
              this.$router.push('/workbench')
            }
          } else {
            this.validate.phoneNum = false
            this.validate.psw = false
            this.imgsrc.captcha = ''
            this.refreshCaptcha()
            this.validate.imgCaptcha = false
            this.validate.allMsg = _data.msg
          }
          this.postFlag = false
        })
        .catch((response) => {
          this.postFlag = false
        })
      // 点击注册、登录按钮
      // this.$store.commit('sensors/registerLoginButtonClick2Sensor')
    },
    /**
     * 存在bdVid参数代表为百度推广链接进入，需要做百度ocpc上报
     */
    async reportBaiduOcpc() {
      const bdVid = this.$.storage.get('bdVid') || null
      if (!bdVid) return
      let params = JSON.parse(bdVid)

      await this.$http.post('/common/baiduoCPC', params)
    },
    //注册后直接登录
    login(acc, psw) {
      this.$http
        .post('/login', {
          account: acc,
          psw: psw
        })
        .then((response) => {
          var _data = response.data
          if (_data.code == 200) {
            this.changeLogin(_data.data)
            this.autoToTool()
            this.reportBaiduOcpc()
            if (this.$route.name == 'workbench-signin') {
              this.$router.push('/workbench')
            }
            //通过非手机账号注册的需要进行绑定手机
            if (!_data.data.phone || _data.data.phone == '' || _data.data.phone == '1') {
              this.$emit('bindPhone')
            } else {
              //手机号注册，直接弹出领取会员
              this.$emit('showVipDialog')
            }
          }
        })
        .catch(function(error) {
          //   console.log(error, '失败')
        })
    },
    //跳转到页面
    goTo(str) {
      this.$emit('goto', str)
    },
    // 登陆成功后自动跳转到工具
    autoToTool() {
      if (Object.keys(this.$route.query).indexOf('login') != -1) {
        //需要自动跳转到工具
        // 路由参数带有url
        let url = decodeURI(this.$route.query.url)
        if (url != 'undefined') {
          window.location.href = url
          return
        }

        // 路有参数中带‘storaBoard'：在故事版点击下一步
        let storyboard = this.$route.query.storyBoard == undefined ? '' : 'storyBoard'
        if (storyboard) {
          window.location.href = window.location.origin + `/tool?${storyboard}`
        }

        // 路由参数带’template'：模板上点击使用
        let checkId = this.$route.query.template === undefined ? '' : this.$route.query.template
        if (checkId) {
          window.location.href = window.location.origin + `/tool?template=${checkId}`
        }
      }
    },
    /**
     * 获取未读信息状态
     */
    checkUnreadInfo() {
      this.$http
        .get('/user/inform/unreadInform')
        .then(({ data }) => {
          if (data.code == 200) {
            // this.changeUnreadMsgInfo(data.data[0].total)
          } else {
            // console.log(`获取未读信息数量失败:`,data.data);
          }
        })
        .catch((err) => {
          // console.log(`err:`,err);
        })
    },
    //判断用户是否第一次登陆，不同的账号存为不同的对象。
    checkLoginTimes(userData) {
      var hasNewTag = true
      var tempUsers = {}
      var localUsers = localStorage.getItem('localUsers')
      if (!localUsers) {
        localUsers = [{ loginTimes: 0, id: userData.id }]
        localStorage.setItem('localUsers', JSON.stringify(localUsers))
      } else {
        localUsers = JSON.parse(localUsers)
        // console.log("localUsers",localUsers,"-----",typeof(localUsers),"----")
        var arrLen = localUsers.length
        for (let i = 0; i < arrLen; i++) {
          if (userData.id != localUsers[i].id) {
            tempUsers.loginTimes = 0
            tempUsers.id = userData.id
          } else {
            hasNewTag = false
          }
        }
        if (hasNewTag) {
          localUsers.push(tempUsers)
        }
        localStorage.setItem('localUsers', JSON.stringify(localUsers))
      }
    },
    // 微信登录的返回按钮
    backClick() {
      this.showWechatLogin = false
      // console.log("点击微信登录返回按钮");
    },
    //其他登录方式
    oauthlogin(val) {
      this.setCookie()
      this.setRouteURL()
      const registerSuccessSource = this.$store.getters['sensors/registerSuccessSource']
      const source = registerSuccessSource ? registerSuccessSource.name : '非指定来源'
      let utmParam = this.$.storage.get('utmParam') || this.routeParam || ''
      switch (val) {
        case 1: // 微博
          var _href = `/webapi/login/weibo?${utmParam}&isAc=${this.isAc}&source=${source}`
          this.openLink(_href)
          break
        case 2: // qq
          _href = `/webapi/login/qq?${utmParam}&isAc=${this.isAc}&source=${source}`
          this.openLink(_href)
          break
        case 3: //微信
          // window.location.href = `/login/wechat?${
          //     utmParam ? utmParam : ""
          // }&isAc=${this.isAc}`;
          this.showWechatLogin = true
          break
      }
      this.checkUnreadInfo()
    },
    openLink(src) {
      let link = document.createElement('a')
      link.target = '_blank'
      link.href = src
      link.click()
    },
    setCookie() {
      let uuid = this.$.generateUuid()
      document.cookie = `laihuatemporarycookie=${uuid}`
    },
    //设置第三方登录存储路由地址
    setRouteURL() {
      // 设置第三方登录后需要跳转到哪个地址
      var toPath = this.$route.name && this.$route.name.includes('wbsignin') ? '/workbench' : window.location.pathname
      sessionStorage.setItem('routeURL', toPath)
      sessionStorage.setItem('routeSearch', window.location.search)
    }
  }
}
</script>
<style lang="scss">
.register-container {
  width: 302px;
  margin: 0 auto;
  border-radius: 5px;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  .register-form {
    // padding: 0 60px;
    // width: 396px;
    text-align: left;
    // background-color: #fafafc;
    box-sizing: border-box;
    // border-radius: 0 0 5px 0;
    &-title {
      display: flex;
      flex-direction: row;
      margin-bottom: 22px;
      p {
        margin-right: 25px;
        font-size: 18px;
        cursor: pointer;
      }
      .title-p-active {
        margin-right: 25px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        padding-bottom: 6px;
        border-bottom: 3px solid #2f58fe;
      }
    }
    .form-box {
      display: flex;
      width: 300px;
      .form {
        width: 188px;
        background-color: #ffffff;
        border: 1px solid #d4d2da;
        border-radius: 4px;
        margin: 0 auto 20px;
        input {
          padding-left: 8px;
          font-size: 14px;
          width: 100px;
          box-sizing: border-box;
        }
      }
      .form-imgcaptcha {
        width: 107px;
        margin-left: 10px;
        height: 40px;
        background: #fff;
        img {
          width: 107px;
          height: 40px;
        }
      }
      .form-getcode {
        margin-top: 0;
        margin-left: 10px;
        width: 107px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-weight: normal;
        color: #fff;
        text-align: center;
        cursor: pointer;
        &:disabled {
          cursor: not-allowed;
          color: #606266;
          background: #ededf6;
        }
      }
    }
    .form {
      position: relative;
      margin-bottom: 20px;
      width: 300px;
      line-height: 40px;
      height: 40px;
      background-color: #fff;
      border: 1px solid #d4d2da;
      border-radius: 4px;
      margin: 0 auto 20px;
      input {
        padding-left: 10px;
        width: 90%;
        font-size: 14px;
        background-color: #fff;
        box-sizing: border-box;
      }
      input::placeholder {
        color: #c7c7c7;
        font-size: 14px;
      }
      label {
        margin-right: 20px;
      }
      .check-right {
        position: absolute;
        right: -30px;
        top: 10px;
        width: 24px;
        height: 24px;
        transform: scale(0.66);
        background: url(./icons/check-right.png) no-repeat;
        &.code-right {
          right: -145px;
        }
      }
      .pwd-clear {
        height: 23px;
        position: absolute;
        right: 26px;
        top: 8px;
      }
      .pwd-show {
        width: 16px;
        height: 16px;
        // background: url("../../assets/img/icon_15/logcomp/pwd-show.png")
        //     no-repeat center / contain;
        cursor: pointer;
        position: absolute;
        right: 2px;
        top: 11px;
        // &.active {
        //     background: url("../../assets/img/icon_15/logcomp/pwd-hide.png")
        //         no-repeat center / contain;
        // }
      }
      .error {
        position: absolute;
        bottom: -16.5px;
        padding-left: 5px;
        width: 290px;
        color: #ff1f2a;
        font-size: 12px;
      }
    }
    button {
      width: 300px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      border-radius: 4px;
      border: none;
      background-color: #5779fa;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      &.sbtn-disabled {
        background-color: #ddd;
        cursor: not-allowed;
      }
    }
    .form-text {
      margin-bottom: 30px;
      label {
        margin-right: 20px;
      }
      .text-number {
        margin-right: 18px;
      }
      .text-btn {
        color: #5779fa;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    a {
      text-align: center;
      font-size: 14px;
      text-decoration: underline;
      color: #5779fa;
      cursor: pointer;
      &.old-login {
        display: block;
        margin-top: 8px;
      }
    }
  }
  .a-desc {
    margin-top: 10px;
    font-size: 12px;
    text-align: left;
    a {
      color: #2f58fe;
      cursor: pointer;
    }
  }
  .login-line {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    width: 300px;
    margin-top: 40px;
    margin-bottom: 21px;
    line-height: 14px;
    font-size: 14px;
    color: #999999;
    &::after {
      position: absolute;
      width: 92px;
      height: 1px;
      right: 0px;
      bottom: 50%;
      content: '';
      background-color: #e4e4e4;
    }
    &::before {
      position: absolute;
      width: 92px;
      height: 1px;
      left: 0px;
      bottom: 50%;
      content: '';
      background-color: #e4e4e4;
    }
  }
  .other-login {
    display: flex;
    justify-content: center;
    position: relative;
    width: 300px;
    .option {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 58px;
      height: 58px;
      border-radius: 50%;
      border: 1px solid #e4e4e4;
      .signinicon1 {
        cursor: pointer;
        width: 30px;
        height: 25px;
      }
      .signinicon2 {
        cursor: pointer;
        width: 30px;
        height: 25px;
      }
      .signinicon3 {
        cursor: pointer;
        width: 24px;
        height: 29px;
      }
      &:hover {
        background-color: #e4e4e4;
      }
    }
  }
}
</style>
